<template>
	<div class="jobs">
		<navbar></navbar>
		<section class="content">
			<p class="md-display-3 bottomSpace">Join us because it's awesome!</p>

			<p class="md-subheading" style="text-align:center; color: indigo">
				Work with us on the most-convinient health tracking software to help the lives of chronic desease patients.
				We are looking for university students, who are determined enough to consider a <br>
				product as their own child, and ready to experiment with new solutions. All of the listed job opportunites are very flexible.
				We can support you with professional practice and public research<br> projects. Please write us,  if you are interested in the healthcare
				field, and you feel like your expertise could be valuable for our project.
			</p>
			<div style="text-align:center">  
				<md-button href="#h1" class=" md-raised md-primary">See open positions</md-button>
			</div>
			<div class="image-container">

				<p class="md-display-3 bottomSpace">Why us?</p>

			
				
					<div class="row">
						<div class="container bottomSpace col-md-6">
							<p> sdsaportunites are very flexible.<br>
								We can support you with professional <br>practice and public research<br>
							</p>
							<img  src="../assets/icons/001-pint.png" alt="we love our team!"> 
						</div>
			
						<div class="container bottomSpace col-md-6">
			
							 <p> sdsaportunites are very flexible.<br>
							We can support you with professional <br>practice and public research<br>  </p>
							<img src="../assets/icons/002-collaboration.png" alt="we love our team!"> 
						</div>
		
						<div class="container bottomSpace col-md-6">
							<p> sdsaportunites are very flexible.<br>
								We can support you with professional <br>practice and public research<br>
							</p>
							<img src="../assets/icons/003-earning.png" alt="we love our team!" > 
			
						</div>
			
						<div class= "container bottomSpace col-md-6">
							<p> sdsaportunites are very flexible.<br>
								We can support you with professional <br>practice and public research<br> 
							</p>
							<img src="../assets/icons/004-student.png" alt="we love our team!"> 
				
						</div>
						</div>
			
		</div>
			<h1 id="h1" class= "md-display-3" style="text-align: center"> Open positions: </h1>
			<div class="md-card-container row ">
				<div v-for="job in jobs" class="col-md-6">
					<md-card class="card">
						<md-card-header class="md-primary">
							<div class="md-title">
								{{job.title}}
							</div>
						</md-card-header>
						<md-card-expand>
							<md-card-actions>
								<md-button class="md-icon-button" md-expand-trigger>
									<md-icon>keyboard_arrow_down</md-icon>
								</md-button>
							</md-card-actions>
							<md-card-content>
								<span class="md-subheading">Description:</span><br>
								<span class="md-body2">{{job.description}}</span>
								<br>

								<md-card-actions>
									<md-button class="md-raised md-primary">Apply</md-button>


								</md-card-actions>
								<span class="footers">
									<span style="strong">Work hours:</span>
									<span > {{job.work_hours + " hours/week"}}</span> <br>
									<span>Salary range:</span>
									<span >{{job.salary_range}} €</span>
								</span>

							</md-card-content>
						</md-card-expand>
					</md-card>
				</div>
			</div>
		</section>
	</div>
</template>

<script>

	import Navbar from './Navbar'

	export default {
		data(){
			return {
				jobs:[{

					title:"javascript frontend developer",
					description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam risus nibh, mollis molestie facilisis tempor, finibus eu ex. Phasellus nec nunc in orci tincidunt varius vel nec felis. Duis lorem nisi, placerat eget euismod auctor, mollis sit amet augue. Maecenas odio justo, tristique quis odio dapibus, luctus rutrum leo. Proin tellus elit, ultricies eu mi et, tempus semper felis. Aliquam quis nulla felis. Curabitur ut vestibulum ex. Quisque tristique arcu dolor, at bibendum urna elementum sit amet.",
					work_hours: "6",
					salary_range:" 25"
				},
				{
					title:"Junior javascript frontend developer",
					description:"Cras at mauris eleifend felis ullamcorper rhoncus vitae et augue. Mauris maximus ligula non lectus condimentum pellentesque. Nulla in turpis est. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras auctor aliquet quam a bibendum. Duis eu sodales quam. Morbi maximus orci ut elementum aliquet. Nulla scelerisque augue malesuada turpis lobortis iaculis. Nullam feugiat nisi ac pretium pharetra. Quisque et sollicitudin est. Aliquam finibus faucibus augue, eget feugiat turpis pretium sodales. Nunc ac neque enim. Nulla mollis lacus neque, ut fringilla turpis gravida id.",
					work_hours: "12",
					salary_range:" 20"
				},
				{
					title:"android developer",
					description:"Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, laoreet nibh. Donec eu sapien auctor urna fermentum rhoncus. Etiam eget luctus eros. Aliquam erat volutpat. Nam sit amet nisl ut erat convallis bibendum eu sed nibh. Aliquam eget enim blandit, molestie turpis et, lobortis libero. Nam fermentum est vel justo tristique, sit amet egestas elit consequat. Fusce posuere efficitur neque id iaculis. Nulla a posuere nunc, eu aliquet odio. Duis quis varius tellus. Vestibulum vulputate tellus ac dui semper, ac semper leo viverra. Donec vitae arcu eu diam bibendum congue sit amet fringilla arcu. Nulla facilisi. Vestibulum quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range:"18"
				},
				{
					title:"android developer",
					description:"Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, laoreet nibh. Donec eu sapien auctor urna fermentum rhoncus. Etiam eget luctus eros. Aliquam erat volutpat. Nam sit amet nisl ut erat convallis bibendum eu sed nibh. Aliquam eget enim blandit, molestie turpis et, lobortis libero. Nam fermentum est vel justo tristique, sit amet egestas elit consequat. Fusce posuere efficitur neque id iaculis. Nulla a posuere nunc, eu aliquet odio. Duis quis varius tellus. Vestibulum vulputate tellus ac dui semper, ac semper leo viverra. Donec vitae arcu eu diam bibendum congue sit amet fringilla arcu. Nulla facilisi. Vestibulum quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range:"18"
				},
				{
					title:"sales manager",
					description:"Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range:"18"
				},
				{
					title:"ios developer",
					description:"Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, laoreet nibh. Donec eu sapien auctor urna fermentum rhoncus. Etiam eget luctus eros. Aliquam erat volutpat. Nam sit amet nisl ut erat convallis bibendum eu sed nibh. Aliquam eget enim blandit, molestie turpis et, lobortis libero. Nam fermentum est vel justo tristique, sit amet egestas elit consequat. Fusce posuere efficitur neque id iaculis. Nulla a posuere nunc, eu aliquet odio. Duis quis varius tellus. Vestibulum vulputate tellus ac dui semper, ac semper leo viverra. Donec vitae arcu eu diam bibendum congue sit amet fringilla arcu. Nulla facilisi. Vestibulum quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range:"18"
				},
				{
					title:"android developer",
					description:"Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, laoreet nibh. Donec eu sapien auctor urna fermentum rhoncus. Etiam eget luctus eros. Aliquam erat volutpat. Nam sit amet nisl ut erat convallis bibendum eu sed nibh. Aliquam eget enim blandit, molestie turpis et, lobortis libero. Nam fermentum est vel justo trtur neque idc vitae arcu eu diam bibendum congue sit amet fringilla arcu. Nulla facilisi. Vestibulum quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range:"18"
				}
				]
			}
		},
		components: {
			Navbar
		},
		mounted(){

		},
	}
</script>

<style scoped>
	.content{
		margin: 16px;
	}

	.bottomSpace{
		margin-bottom: 64px;
	}

	.card{
		max-width: 500px;
		max-height: 500px;
		border-radius:25px;
		margin-bottom: 16px;
		margin-top: 16px;


		

	}
	.md-card-container{
		max-width: 1200px;

		
		margin-right: auto;
    	margin-left: auto;
	}

	p{
	
		color: indigo;
		text-align: center;
		
	}


    
   	img{
   		max-width: 200px;
   		border-radius: 50px;
   		margin-left: 32px;

   	
	}
	.md-title{
		color: indigo;
	}
	.footers{
		font-weight: bold;
	}
	
	.md-display-3{
		text-align: center;
	}
	.image-container{
		background-color: white;
		margin: 0 auto;
		max-width: 1200px;
		border-radius: 50px;
		text-align:center;
		
  	

	}

</style>



// WEBPACK FOOTER //
// JobsView.vue?5e9a803d